import React from "react";
import "./Newsletter.css"; // Import the CSS file for styling

const Newsletter = () => {
  return (
    <div className="newsletter-container">
      <div className="coming-soon">
        <h1>Coming Soon</h1>
      </div>
    </div>
  );
};

export default Newsletter;